import {PropsWithChildren} from "react";

interface PageContentProps extends PropsWithChildren {
}

const PageContent = ({children}: PageContentProps) => {

    return (
        <div className={`page__content`}  id={"main-content"} tabIndex={-1}>
            {children}
        </div>
    );

}

export default PageContent;